import {
  GridColumnMenuFilter,
  GridColumnMenuSort,
} from "@progress/kendo-react-grid";
import React, { Component } from "react";

export default class ColumnMenu extends Component {

  render() {
    return (
      <div className="risksFilter">
        {/* <GridColumnMenuSort {...this.props} /> */}
        <GridColumnMenuFilter  {...this.props} expanded={true} />
      </div>
    );
  }
}
